
import styled from 'styled-components'
import {Link as LinkS} from 'react-scroll'



/*Container,
  BgImage,
  IntroHeader,
  IntroText,
  IntroBtn*/

  export const Container = styled.div`
    height: 100vh;
    width: 100%;
    text-align: justify;
    color: white;
    margin-top:-80px
    `
    
  export const BgImage = styled.div`
    background-image: url("${props => props.intro}");
    background-size: cover;
    filter: brightness(.4);
    top: 0;
    left: 0;
    z-index: -2;
    width: 100%;
    height: 100vh;
  `

  export const IntroHeader = styled.h3`
    color:black; 
    display: block;
    vertical-align: middle;
    margin: auto;
  `

  export const IntroText = styled.h5`
    color: gray;
    margin: auto;
  `

  export const IntroBtn = styled(LinkS)`
    white-space: nowrap;
    padding: 10px 22px;
    width: 200px;
    margin-top: 30px;
    font-size: 1rem;
    outline: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    border: 3px solid #1F94C2;

    &:hover{
        transition: all 0.2 ease-in-out;
        background: #1F94C2;
    }
    
  `

